import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import CourseIcon from "../ui/icons/course-icon";

// <i className="fa-solid fa-chevron-right"></i>
import {
  faArrowUpRightFromSquare,
  faClock,
  faRemove,
  faXmarkLarge,
  faHome,
  faBookOpenCover,
  faCircleInfo,
  faSignIn,
  faDashboard,
  faCartShopping,
  faUser,
  faArrowLeftFromLine,
  faFilter,
  faGridRound2,
  faListOl,
  faQuoteLeft,
  faChevronRight,
  faChevronLeft,
  faLocationDot,
  faCalendarDays,
  faCalendarXmark,
  faAngleDown,
  faAngleRight,
  faInfoCircle,
  faCheck,
  faCircleCheck,
  faCircleXmark,
  faBookOpen,
  faLandmark,
  faLaptopHouse,
  faCommentsQuestion,

// categories
  faGavel,
  faLaptop,
  faGlobe,
  faUniversity,
  faBuilding,
  faBarChart,
  faDollar,
  faMedkit,
  faEdit,
  faCalendar,
  faPlane,
  faPhone,
  faSearch,
  faSuitcase,
  faTag,
  faStar,
  faTasks,
  faThumbsUp,
  faThumbsDown,
  faTree,
  faShield,
  faHeart,
  faGift,
  faPlay,
  faBell,
  faRss,
  faVideoCamera,

// material sections
  faIcons,
  faBook,
  faGrid2,
  faFrame,
  faObjectsColumn,
  faGrid,
  faFilm,
  faSparkles,
  faVolume,
  faEye,
  faFolderOpen,
  faEarthAmericas,
  faUsers,
  faHandHoldingHeart,

// materials

  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileZipper,
  faImage,
  faFileMusic,
  faVideo,
  faLink,
  faFile,
  faFiles,
  faFilterSlash,
} from '@fortawesome/pro-regular-svg-icons'


library.add(
  faClock,
  faFilterSlash,
  faArrowUpRightFromSquare,
  faRemove,
  faXmarkLarge,
  faHome,
  faBookOpenCover,
  faCircleInfo,
  faSignIn,
  faDashboard,
  faCartShopping,
  faUser,
  faArrowLeftFromLine,
  faFilter,
  faGridRound2,
  faListOl,
  faQuoteLeft,
  faChevronRight,
  faChevronLeft,
  faLocationDot,
  faCalendarDays,
  faCalendarXmark,
  faAngleDown,
  faAngleRight,
  faInfoCircle,
  faCheck,
  faCircleCheck,
  faCircleXmark,
  faBookOpen,
  faLandmark,
  faLaptopHouse,
  faCommentsQuestion,

// categories
  faGavel,
  faLaptop,
  faGlobe,
  faUniversity,
  faBuilding,
  faBarChart,
  faDollar,
  faMedkit,
  faEdit,
  faCalendar,
  faPlane,
  faPhone,
  faSearch,
  faSuitcase,
  faTag,
  faStar,
  faTasks,
  faThumbsUp,
  faThumbsDown,
  faTree,
  faShield,
  faHeart,
  faGift,
  faPlay,
  faBell,
  faRss,
  faVideoCamera,

// material sections
  faIcons,
  faBook,
  faGrid2,
  faFrame,
  faObjectsColumn,
  faGrid,
  faFilm,
  faSparkles,
  faVolume,
  faEye,
  faFolderOpen,
  faEarthAmericas,
  faUsers,
  faHandHoldingHeart,

// materials
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileZipper,
  faImage,
  faFileMusic,
  faVideo,
  faLink,
  faFile,
  faFiles,)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('course-icon', CourseIcon)